module.exports = {
	"articleTitle1": "Betsa reaches new heights in early season ",
	"catImage": "redstar.png",
	"totalCats": 1,
	"name": "Alumni Field",
	"articleLink2": "https://www.michigandaily.com/content/dedication-game-special-hutchins-players-and-alums",
	"articleSnippet1": "Mar 8, 2017 ... Senior pitcher Megan Betsa in a game against the University of Missouri at \nAlumni Field in May 2016. Marina Ross/Daily. Max Marcovitch.",
	"articleSnippet2": "Apr 28, 2008 ... Following Friday's ceremonial dedication game at Alumni Field at the Wilpon \nBaseball and Softball Complex, Michigan softball coach Carol ...",
	"totalMisc": 0,
	"articleTitle2": "Dedication game special for Hutchins, players and alums",
	"address": "1255 S State St, Ann Arbor, MI 48104",
	"images": [
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/170314/jam.NEW_.SynderProtest.5.18.16.159.jpg?itok=YcSHKhN1",
			"author": "Jeremy Mitnick",
			"caption": "The Michigan softball team will seek to replace graduated stars who anchored two consecutive trips to the Women’s College World Series."
		},
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/160614/amf.SFT_.vswisconsin.hutchins.jpg?itok=qd4MQm_J",
			"author": "Allison Farrand",
			"caption": "Carol Hutchins was honored April 15 for becoming the winningest coach in NCAA Softball history."
		}
	],
	"position": {
		"lat": 42.266587,
		"lng": -83.743018
	},
	"tips": [
		{
			"text": "Our softball team plays here and is consistently a national championship contending team. I would highly recommend wathching them play at least once.",
			"person": "Erik Forkin"
		}
	],
	"articleLink1": "#",
	"categories": {
		"misc": 1,
		"location": 1,
		"athleticfacility": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/alumnifield.json
// module id = 807
// module chunks = 0